import { AnyAction, Store } from 'redux';
import { DesignerParams } from '@/types';
import { StoreDispatch, StoreState } from '@/redux/types';

function loadStore() {
  return import(/* webpackChunkName: 'store', webpackPreload: true */ '@/redux/store');
}

export function loadLazyStore(params: DesignerParams) {
  let loadedStore: Store<StoreState, AnyAction>;
  const actionQueue: AnyAction[] = [];
  const storePromise = loadStore()
    .then(({ init }) => init(params))
    .then((store) => {
      loadedStore = store;
      const { dispatch } = store;
      actionQueue.forEach((obj) => dispatch(obj));
      return store;
    });

  // @ts-ignore
  const lazyDispatch: StoreDispatch = (action) => {
    if (loadedStore) {
      return loadedStore.dispatch(action);
    }

    if (typeof action === 'function') {
      return action(lazyDispatch, () => {
        throw new Error('Do not use getState in initialization actions');
      });
    } else {
      actionQueue.push(action);
    }
  };

  return [storePromise, lazyDispatch] as const;
}

export function getInitialDraft(
  parameter: DesignerParams,
  dispatch: StoreDispatch,
  getState: () => StoreState
) {
  return loadStore().then(({ getInitialDraft }) => getInitialDraft(parameter, dispatch, getState));
}
